module.exports = __webpack_public_path__ + "img/دروازه-ایی(2).51a9a41f.png";